import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { expenseKeys } from '@/lib/query-keys';
import { expenseService } from '@/services/expense.service';

export function useExpenseCategories() {
  const queryClient = useQueryClient();

  const categoriesQuery = useQuery({
    queryKey: expenseKeys.categories(),
    queryFn: () => expenseService.getCategories(),
  });

  const createCategory = useMutation({
    mutationFn: (data: Parameters<typeof expenseService.createCategory>[0]) => expenseService.createCategory(data),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: expenseKeys.categories() }); toast.success('Category created'); },
    onError: () => toast.error('Failed to create category'),
  });

  const updateCategory = useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof expenseService.updateCategory>[1] }) => expenseService.updateCategory(id, data),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: expenseKeys.categories() }); toast.success('Category updated'); },
    onError: () => toast.error('Failed to update category'),
  });

  const deleteCategory = useMutation({
    mutationFn: (id: string) => expenseService.deleteCategory(id),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: expenseKeys.categories() }); toast.success('Category deleted'); },
    onError: () => toast.error('Failed to delete category'),
  });

  return {
    categories: categoriesQuery.data?.data ?? [],
    isLoading: categoriesQuery.isLoading,
    createCategory, updateCategory, deleteCategory,
  };
}
